import { Clock } from "lucide-react";
import Skeleton from "react-loading-skeleton";

export default function FilesListSkeleton() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl shadow hover:shadow-lg transition p-3 relative group cursor-pointer"
        >
          {/* Preview */}
          <div className="w-full h-32 bg-gray-100 rounded-xl overflow-hidden">
            <Skeleton className="w-full h-full" />
          </div>

          {/* Info */}
          <div className="mt-3 space-y-1">
            <p className="text-sm font-medium truncate">
              <Skeleton />
            </p>

            <div className="flex items-center gap-1 text-xs text-gray-500">
              <Clock size={12} />
              <Skeleton width={50} />
            </div>

            <button className="text-xs text-indigo-600 hover:underline">
              <Skeleton width={40} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
